export const isLocalhost = false // window.location.host.includes('localhost:')

export const API_KEY = 'WQICEXP15FX9UXTWSV6SMGRCHI3R5VJAAA'

export const defaultScan = isLocalhost ? 'https://testnet.bscscan.com' : 'https://bscscan.com'
export const defaultScanApi = isLocalhost ? 'https://api-testnet.bscscan.com' : 'https://api.bscscan.com'

export const cnrAddress = '0xdcba3fbd7bbc28abd18a472d28358089467a8a74'
export const greenHouseAddress = '0xAAEF84aaDA7570DFb53ed1611f8Ca67737196598'


export const defaultNetwork = isLocalhost ? 97 : 56

export const walletConnectOpts = {
//     infuraId: '97a6f1404cf746bbb78a35045d9dd35a', // required TODO add for Kovan/Bsscan // binance not
    network: 'binance',
    chainId: 56,
    rpc: {
        97: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
        56: 'https://bsc-dataseed.defibit.io',
    }
}

export const networksConfig = {
    56: {
        chainId: '0x38',
        code: 'mainnet',
        explorerURL: 'https://bscscan.com',
        metamaskSettings: {
            method: 'wallet_addEthereumChain',
            params: [{
                chainId: '0x38',
                chainName: 'Binance Smart Chain',
                nativeCurrency: {
                    name: 'Binance Coin',
                    symbol: 'BNB',
                    decimals: 8
                },
                rpcUrls: ['https://bsc-dataseed.defibit.io'],
                blockExplorerUrls: ['https://bscscan.com']
            }]
        }
    },
    97: {
        chainId: '0x61',
        code: 'testnet',
        explorerURL: 'https://testnet.bscscan.com',

        metamaskSettings: {
            method: 'wallet_addEthereumChain',
            params: [{
                chainId: '0x61',
                chainName: 'Testnet Binance Smart Chain',
                nativeCurrency: {
                    name: 'Binance Coin',
                    symbol: 'BNB',
                    decimals: 8
                },
                rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
                blockExplorerUrls: ['https://testnet.bscscan.com']
            }]
        }
    }
}